import { Link } from 'react-router-dom';

interface BreadcrumbsProps {
    currentPage: string;
}

const breadcrumbsStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '1rem',
    fontSize: '0.9rem',
};

const breadcrumbLinkStyle: React.CSSProperties = {
    color: 'var(--brand-color-1)',
    textDecoration: 'none',
    fontWeight: 500,
};

const breadcrumbSeparatorStyle: React.CSSProperties = {
    color: 'var(--text-secondary)',
};

const breadcrumbCurrentStyle: React.CSSProperties = {
    color: 'var(--text-secondary)',
    fontWeight: 500,
};

export function Breadcrumbs({ currentPage }: BreadcrumbsProps) {
    return (
        <nav aria-label="breadcrumb" style={breadcrumbsStyle}>
            <Link to="/" style={breadcrumbLinkStyle}>
                Dashboard
            </Link>
            <span style={breadcrumbSeparatorStyle}>/</span>
            <span style={breadcrumbCurrentStyle} aria-current="page">{currentPage}</span>
        </nav>
    );
}
